import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDashboardComponent } from 'src/app/pages/dynamic-dashboard/dynamic-dashboard.component';
import { DynamicList2Component } from 'src/app/pages/dynamic-list-2/dynamic-list-2.component';
import { ApplicationResourcesService } from './application-resources.service';
import { BaseResourceService } from './base/base-resource.service';
import { ApplicationResourceType } from './models/application-resource';
import {
  DynamicDashboardContent,
  DynamicListContent,
  DynamicFormContent,
} from './models/page-resource-content';
import { PageResourceData } from './models/page-resource-data';
import { DynamicFormPageComponent } from 'src/app/pages/dynamic-form-page/dynamic-form-page.component';

@Injectable({ providedIn: 'root' })
export class PagesService extends BaseResourceService<PageResourceData> {
  type: ApplicationResourceType = 'PAGE';

  constructor(
    _applicationResourceService: ApplicationResourcesService,
    private router: Router
  ) {
    super(_applicationResourceService);
  }

  private getValidPages(component: string) {
    return this.getResources().filter((page) => {
      if (!page.data?.component) {
        console.error(`[PagesService] PAGE resource "${page.name}" (${page.id}) is missing data or component — skipped`);
        return false;
      }
      return page.data.component === component;
    });
  }

  initializeDynamicLists() {
    this.getValidPages('dynamicDatalist').forEach((page) => {
      this.router.config[0].children.unshift({
        // todo: [0] seems too hacky, think about linking this to route main routes (path: "")
        path: page.data.route,
        data: page.data.content as DynamicListContent,
        component: DynamicList2Component,
      });
    });
  }

  initializeDynamicDashboards() {
    this.getValidPages('dynamicDashboard').forEach((page) => {
      this.router.config[0].children.unshift({
        // todo: [0] seems too hacky, think about linking this to route main routes (path: "")
        path: page.data.route,
        data: page.data.content as DynamicDashboardContent,
        component: DynamicDashboardComponent,
      });
    });
  }

  initializeDynamicForms() {
    this.getValidPages('dynamicForm').forEach((page) => {
      this.router.config[0].children.unshift({
        // todo: [0] seems too hacky, think about linking this to route main routes (path: "")
        path: page.data.route,
        data: page.data.content as DynamicFormContent,
        component: DynamicFormPageComponent,
      });
    });
  }
}
